import InviteClient from './InviteClient';

export default InviteClient;
